import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { AdmihairBaseComponent } from 'src/app/admihair/components/admihair-base.component';
import { BloqueioAgendaService } from 'src/app/admihair/service/bloqueio-agenda.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AgendaEmpresaService } from 'src/app/admihair/service/agenda-empresa.service';
import { BloqueioAgendaResponse } from 'src/app/admihair/api/dto/bloqueio-agenda-response';

@Component({
  selector: 'app-bloqueio-detalhe',
  templateUrl: './bloqueio-detalhe.component.html',
  styleUrls: ['./bloqueio-detalhe.component.scss']
})
export class BloqueioDetalheComponent extends AdmihairBaseComponent implements OnChanges {

  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Input() bloqueioId?: number;
  @Output() excluir = new EventEmitter<boolean>();
  bloqueio?: BloqueioAgendaResponse;

  constructor(private bloqueioAgendaService: BloqueioAgendaService,
    private agendaEmpresaService: AgendaEmpresaService,
    private confirmationService: ConfirmationService,
    erroService: ErroService,
    storageService: UtilStorageService) {
    super(erroService, storageService);
  }

  ngOnChanges(changes: SimpleChanges): void {
      if (changes['visible']?.currentValue === true) {
        this.carregarDados();
      }
    }
  

  carregarDados() {
    this.bloqueioAgendaService.buscarPorId(this.bloqueioId!).subscribe({
      next: (data: BloqueioAgendaResponse) => {
        this.bloqueio = data;
      },
      error: (err: any) => {

      }
    })
  }



  excluirBloqueio() {

    if(!this.bloqueio) {
      return;
    }
    const idBloqueio = this.bloqueio.id!;
   
    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.bloqueioAgendaService.excluir(idBloqueio).subscribe({
          next: () => {
            this.excluir.emit(true);
            this.fechar();
          },
          error: (err: any) => {
            this.exibirMensagemErroDialog(err);
          }
        })
      }
    });
  }



  fechar() {
    this.messagesDialog = [];
    this.visibleChange.emit(false);
  }

}
